module.exports = __webpack_public_path__ + "static/profile-5f35db5881b478c4e80369f307e2c4fb.png";